import { Table } from 'antd'

export default function SkuTable(props: any) {
  const { columns, data } = props
  return <Table columns={columns} dataSource={data} />
}
